
import { ProductModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { Component, Prop, Ref, VModel, Vue, Watch } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { productsStore } from '@/libs/products/+state/store';

@Component({})
export default class ProductSelect extends Vue {
    @VModel() innerValue!: string;
    @Prop({ default: '' }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!: [any[]];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: false }) multiple!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: false }) marginTop6!: boolean;
    @Prop() placeholder!: string;
    @Prop() attach!: string;
    @Prop() includeCodeInName!: string;

    @Ref() autocomplete!: Autocomplete;

    get items(): ProductModel[] {
        return [...(productsStore.useGetter(CrudGetter.Data) as ProductModel[])]
            .sort((a: ProductModel, b: ProductModel) => {
                if (a.name! < b.name!) {
                    return -1;
                }
                if (a.name! > b.name!) {
                    return 1;
                }
                return 0;
            })
            .map((e) => {
                const item = { ...e };
                if (this.includeCodeInName && item.code) {
                    item.name = `${item.name} (${item.code})`;
                }
                return item;
            });
    }

    onChange(e: any) {
        const products = (productsStore.useGetter(CrudGetter.Data) ?? []) as ProductModel[];
        this.$emit('input', e);
        this.$nextTick(() => {
            this.$emit('change', e);
            this.$emit('select', products.filter((x) => x.id == e).shift() ?? null);
        });
    }
}
